import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import "../../../../../App.css";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";

function BankDetailsNew({
  reduxData,
  onClickPrevious,
  onClickNext,
  onClickCancel
}) {
  const [loading, setLoading] = useState();
  const [bankName, setBankName] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [nameAsbank, setNameasBank] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [revenueAccNumber, setRevenueAccNumber] = useState("");
  const [debitorAccNumber, setDebitorAccNumber] = useState("");
  const [debitorAccNumber1, setDebitorAccNumber1] = useState("");
  const [revenueAccIfsc, setRevenueAccIfsc] = useState("");
  const [debitorAccIfsc, setDebitorAccIfsc] = useState("");
  const [debitorAccIfsc1, setDebitorAccIfsc1] = useState("");
  const [corporateId, setCorporateId] = useState("");
  const [userId, setUserId] = useState("");
  const [showDebitorAccountDetails, setShowDebitorAccountDetails] =
    useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#000000"
  };
  const containerStyle = {
    width: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px"
  };

  useEffect(() => {
    if (!reduxData) return;

    if (
      reduxData?.service?.serviceType === "payin" ||
      reduxData?.service?.serviceType === "van" ||
      reduxData?.service?.serviceType === "voucher"
    ) {
      if (
        reduxData?.bankAccountNumber !== "" &&
        reduxData?.bankIfscCode !== "" &&
        reduxData?.nameAsbank !== ""
      ) {
        setBankName(reduxData?.bankName);
        setBankAccountNumber(reduxData?.bankAccountNumber);
        setIfscCode(reduxData?.bankIfscCode);
        setNameasBank(reduxData?.nameAsPerBank);
      }
    } else if (reduxData?.service?.serviceType === "payout") {
      if (
        reduxData?.service?.serviceProviderName?.toUpperCase() === "EQUITAS" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "IDFC"
      ) {
        setShowDebitorAccountDetails(true);
        setDebitorAccIfsc(reduxData?.debitorAccIfsc);
        setDebitorAccNumber(reduxData?.debitorAccNumber);
        setRevenueAccIfsc(reduxData?.revenueAccIfsc);
        setRevenueAccNumber(reduxData?.revenueAccNumber);
        setCorporateId(reduxData.corpId);
        setUserId(reduxData?.userId);
      }
      if (
        reduxData?.service?.serviceProviderName?.toUpperCase() === "CASHFREE"
      ) {
        setShowDebitorAccountDetails(false);
        setDebitorAccIfsc(reduxData?.debitorAccIfsc);
        setDebitorAccNumber(reduxData?.debitorAccNumber);
        setDebitorAccIfsc1(reduxData?.debitorAccIfsc1);
        setDebitorAccNumber1(reduxData?.debitorAccNumber1);
      }

      if (
        reduxData?.remitterAccountNumber !== "" &&
        reduxData?.remitterIfscCode !== "" &&
        reduxData?.remitterNameAsPerBank !== ""
      ) {
        setBankName(reduxData?.bankName);
        setBankAccountNumber(reduxData?.remitterAccountNumber);
        setIfscCode(reduxData?.remitterIfscCode);
        setNameasBank(reduxData?.remitterNameAsPerBank);
      }
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        margin: "4% 0",
        position: "relative"
      }}
    >
      <p style={styles.title}>Bank Details</p>
      <p style={styles.p}>Please Provide the bank details as mentioned below</p>
      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C"
        }}
      ></div>

      {reduxData?.service?.serviceProviderName?.toLowerCase() !== "axis" &&
      reduxData?.service?.serviceProviderName?.toLowerCase() !== "idfc" &&
      showDebitorAccountDetails ? null : (
        <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Bank Name</label>
            <CustomInput
              value={bankName}
              onChange={(data) => setBankName(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Bank Name"
              validator="businessName"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Name as per the bank</label>
            <CustomInput
              value={nameAsbank}
              onChange={(data) => setNameasBank(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Name as per the bank"
              validator="alphaNumeric"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
              maxLength={50}
            />
          </div>

          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Account Number</label>
            <CustomInput
              value={bankAccountNumber}
              onChange={(data) => setBankAccountNumber(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Account Number"
              validator="accountNumber"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>

          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>IFSC</label>
            <CustomInput
              value={ifscCode}
              onChange={(data) => setIfscCode(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="IFSC"
              validator="ifscCode"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
        </div>
      )}

      {showDebitorAccountDetails && (
        <>
          <div>
            {reduxData?.service?.serviceProviderName?.toLowerCase() !==
              "axis" &&
            reduxData?.service?.serviceProviderName?.toLowerCase() !==
              "idfc" ? (
              <>
                <p style={{ marginBottom: "10px" }}>Revenue Account Details</p>
                <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Revenue Account Number</label>
                    <CustomInput
                      value={revenueAccNumber}
                      onChange={(data) => setRevenueAccNumber(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Revenue Account Number"
                      validator="accountNumber"
                      type="input"
                      inputStyles={{
                        ...containerStyle
                      }}
                    />
                  </div>

                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Revenue Account IFSC</label>
                    <CustomInput
                      value={revenueAccIfsc}
                      onChange={(data) => setRevenueAccIfsc(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Revenue IFSC"
                      validator="ifscCode"
                      type="input"
                      inputStyles={{
                        ...containerStyle
                      }}
                    />
                  </div>
                </div>
              </>
            ) : null}
          </div>

          <>
            <p style={{ marginBottom: "10px" }}>
              {reduxData?.service?.serviceProviderName?.toLowerCase() === "axis"
                ? "Axis"
                : reduxData?.service?.serviceProviderName?.toLowerCase() ===
                  "equitas"
                ? "Equitas"
                : reduxData?.service?.serviceProviderName?.toLowerCase() ===
                  "idfc"
                ? "IDFC"
                : reduxData?.service?.serviceProviderName?.toLowerCase() ===
                  "zyro"
                ? "ICICI"
                : null}{" "}
              Debitor Account Details
            </p>
            <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
              {reduxData?.service?.serviceProviderName?.toLowerCase() ===
                "zyro" && (
                <>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Corporate ID</label>
                    <CustomInput
                      value={corporateId}
                      onChange={(data) => setCorporateId(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Corporate Id"
                      validator="alphaNum"
                      type="input"
                      inputStyles={{
                        ...containerStyle
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>User ID</label>
                    <CustomInput
                      value={userId}
                      onChange={(data) => setUserId(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="User Id"
                      validator="alphaNum"
                      type="input"
                      inputStyles={{
                        ...containerStyle
                      }}
                    />
                  </div>
                </>
              )}

              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Debitor Account Number</label>
                <CustomInput
                  value={debitorAccNumber}
                  onChange={(data) => setDebitorAccNumber(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Debitor Account Number"
                  validator="accountNumber"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>

              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Debitor Account IFSC</label>
                <CustomInput
                  value={debitorAccIfsc}
                  onChange={(data) => setDebitorAccIfsc(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Debitor IFSC"
                  validator="ifscCode"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
            </div>
          </>
        </>
      )}

      {reduxData?.service?.serviceProviderName?.toLowerCase() ===
        "cashfree" && (
        <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Debitor Account Number</label>
            <CustomInput
              value={debitorAccNumber}
              onChange={(data) => setDebitorAccNumber(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Debitor Account Number"
              validator="accountNumber"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Debitor Account IFSC</label>
            <CustomInput
              value={debitorAccIfsc}
              onChange={(data) => setDebitorAccIfsc(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Debitor IFSC"
              validator="ifscCode"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Debitor Account Number</label>
            <CustomInput
              value={debitorAccNumber1}
              onChange={(data) => setDebitorAccNumber1(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Debitor Account Number"
              validator="accountNumber"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Debitor Account IFSC</label>
            <CustomInput
              value={debitorAccIfsc1}
              onChange={(data) => setDebitorAccIfsc1(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Debitor IFSC"
              validator="ifscCode"
              type="input"
              inputStyles={{
                ...containerStyle
              }}
            />
          </div>
        </div>
      )}

      <div style={{ display: "flex", marginTop: "40px" }}>
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",
              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={() => {
              const ifscRegex = /^[A-Za-z]{4}[0]\w{6}$/;
              console.log(
                !bankName || !nameAsbank || !bankAccountNumber || !ifscCode,
                !showDebitorAccountDetails
              );
              if (
                (!bankName || !nameAsbank || !bankAccountNumber || !ifscCode) &&
                !showDebitorAccountDetails
              ) {
                enqueueSnackbar("Please fill all details", {
                  variant: "error"
                });
                return;
              }
              if (bankAccountNumber && bankAccountNumber.length < 9) {
                enqueueSnackbar("Invalid account Number", {
                  variant: "error"
                });
                return;
              } else if (ifscCode && ifscRegex.test(ifscCode) === false) {
                enqueueSnackbar("Invalid ifsc code", {
                  variant: "error"
                });
                return;
              }
              if (
                reduxData?.service?.serviceType?.toLowerCase() === "payout" &&
                reduxData?.service?.serviceProviderName?.toLowerCase() ===
                  "cashfree"
              ) {
                const isValidAccNumber = (accNumber) =>
                  accNumber && accNumber.length >= 9 && accNumber.length <= 19;
                const isValidIfsc = (ifsc) => ifsc && ifscRegex.test(ifsc);

                if (
                  !isValidAccNumber(debitorAccNumber) ||
                  !isValidAccNumber(debitorAccNumber1) ||
                  !isValidIfsc(debitorAccIfsc) ||
                  !isValidIfsc(debitorAccIfsc1) ||
                  !bankName ||
                  !nameAsbank ||
                  !bankAccountNumber ||
                  !ifscCode
                ) {
                  enqueueSnackbar("Please fill all fields", {
                    variant: "error"
                  });
                  return;
                }

                onClickNext({
                  bankName: bankName ?? "",
                  remitterNameAsPerBank: nameAsbank ?? "",
                  remitterAccountNumber: bankAccountNumber ?? "",
                  remitterIfscCode: ifscCode ?? "",
                  debitorAccIfsc: debitorAccIfsc,
                  debitorAccNumber: debitorAccNumber,
                  debitorAccNumber1: debitorAccNumber1,
                  debitorAccIfsc1: debitorAccIfsc1
                });
              }
              if (
                reduxData?.service?.serviceType === "payin" ||
                reduxData?.service?.serviceType === "voucher" ||
                reduxData?.service?.serviceType === "van" ||
                reduxData?.service?.serviceType === "van-upi"
              ) {
                onClickNext({
                  bankName: bankName ?? "",
                  nameAsPerBank: nameAsbank ?? "",
                  bankAccountNumber: bankAccountNumber ?? "",
                  bankIfscCode: ifscCode ?? "",
                  remitterNameAsPerBank: "",
                  remitterAccountNumber: "",
                  remitterIfscCode: ""
                });
              } else if (
                reduxData?.service?.serviceType?.toLowerCase() === "payout"
              ) {
                let equiAccounts = {};
                if (
                  reduxData?.service?.serviceProviderName?.toLowerCase() ===
                    "equitas" ||
                  reduxData?.service?.serviceProviderName?.toLowerCase() ===
                    "zyro" ||
                  reduxData?.service?.serviceProviderName?.toLowerCase() ===
                    "axis" ||
                  reduxData?.service?.serviceProviderName?.toLowerCase() ===
                    "idfc"
                ) {
                  if (
                    ifscRegex.test(debitorAccIfsc) === false ||
                    !debitorAccNumber
                  ) {
                    enqueueSnackbar("Enter valid debitor account details", {
                      variant: "error"
                    });
                    return;
                  }

                  if (
                    reduxData?.service?.serviceProviderName?.toLowerCase() !==
                      "axis" &&
                    reduxData?.service?.serviceProviderName?.toLowerCase() !==
                      "idfc" &&
                    (!revenueAccNumber ||
                      ifscRegex.test(revenueAccIfsc) === false)
                  ) {
                    enqueueSnackbar("Enter valid Revenue account details", {
                      variant: "error"
                    });
                    return;
                  }
                  if (reduxData?.service?.serviceProviderName === "zyro") {
                    if (!corporateId || !userId) {
                      enqueueSnackbar("Enter all  details ", {
                        variant: "error"
                      });
                      return;
                    }
                  }
                  equiAccounts = {
                    revenueAccNumber,
                    revenueAccIfsc,
                    debitorAccIfsc,
                    debitorAccNumber,
                    corpId: corporateId,
                    userId
                  };
                }

                if (
                  reduxData?.service?.serviceProviderName?.toUpperCase() ===
                    "ZYRO" ||
                  reduxData?.service?.serviceProviderName?.toUpperCase() ===
                    "EQUITAS"
                ) {
                  if (
                    equiAccounts.revenueAccIfsc.length !== 11 ||
                    equiAccounts.debitorAccIfsc.length !== 11
                  ) {
                    enqueueSnackbar("Please provide valid IFSC code ", {
                      variant: "error"
                    });
                    return;
                  }
                  if (
                    equiAccounts.revenueAccNumber.length < 9 ||
                    equiAccounts.debitorAccNumber.length < 9 ||
                    equiAccounts.revenueAccNumber.length > 19 ||
                    equiAccounts.debitorAccNumber.length > 19
                  ) {
                    enqueueSnackbar("Please provide valid Account Number  ", {
                      variant: "error"
                    });
                    return;
                  }
                }

                onClickNext({
                  nameAsPerBank: "",
                  bankAccountNumber: "",
                  bankIfscCode: "",
                  bankName: bankName ?? "",
                  remitterNameAsPerBank: nameAsbank ?? "",
                  remitterAccountNumber: bankAccountNumber ?? "",
                  remitterIfscCode: ifscCode ?? "",
                  ...equiAccounts
                });
              }

              return;
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default BankDetailsNew;

const styles = {
  title: {
    fontSize: "24px",
    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content"
  },
  p: {
    color: "#6C6B6B",

    fontWeight: "400",
    fontSize: "14px"
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    color: "#1E2234"
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px"
  },
  add: {
    width: "130px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "8px"
  }
};
